import { createContext, useContext } from 'react';

import { TUpdateAgentPreferenceBodySchema, TUserPreference } from '@cloud-wave/neon-common-lib';

import { TValidateAddressResponse } from './MyLocationModal/types';
import agentDefaultPreference from './constants/agentDefaultPreference';

export type TPreferencesContext = {
  state: {
    preferenceModalOpen: boolean;
    agentPreference: TUserPreference;
    preferredDateFormat: string;
  };
  actions: {
    setPreferenceModalOpen: (openValue: boolean) => void;
    updatePreference: (agentPreference: TUpdateAgentPreferenceBodySchema) => Promise<void>;
    validateAddress: (location: TUpdateAgentPreferenceBodySchema['location']) => Promise<TValidateAddressResponse>;
  };
};

const Context = createContext<TPreferencesContext>({
  state: {
    preferenceModalOpen: false,
    agentPreference: agentDefaultPreference,
    preferredDateFormat: 'dd/MM/yyyy',
  },
  actions: {
    setPreferenceModalOpen: () => {},
    updatePreference: async () => {},
    validateAddress: async () => ({
      valid: false,
      message: '',
    }),
  },
});

export default Context;

export const useAgentPreferencesContext = () => useContext(Context);
